import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import styled from 'react-emotion';
import { Title, TextBody } from 'web-ui-components/lib/atoms/text';
import TemplateList from '../TemplateList/TemplateList';
import templateSelectorContent from './templateSelector.content';
import withContent from '../../containers/withContent';
import { getIsTemplateListEmpty } from '../../states/templates/selectors';
import { TYPE_CHAPS } from '../../config';

const StyledTemplateSection = styled('div')`
	display: flex column;
	margin-top: 48px;
	margin-bottom: 48px;

	.template-row {
		display: flex;
		background-color: #f7f7f7;
		margin-bottom: 2px;
		border-radius: 4px;
		align-items: center;
		padding: 4px;
		justify-content: space-between;
	}

	.edit-section {
		border-left: 1px solid #eee;
	}

	.template-controls {
		margin-top: 8px;
	}
`;

const mapState = (state, props) => ({
	isTemplateListEmpty: getIsTemplateListEmpty(state, props.paymentType),
});
const getTemplateTitle = (paymentType, chapsHeader, header) => (paymentType === TYPE_CHAPS ? chapsHeader : header);

const TemplateSelector = ({
	handleCreateNewTemplate,
	paymentType,
	content: { header, description, createTemplateButtonText, descriptionNoTemplates, chapsHeader },
	isTemplateListEmpty,
}) => (
	<StyledTemplateSection>
		<Title size="h3">{getTemplateTitle(paymentType, chapsHeader, header)}</Title>

		<TextBody>{isTemplateListEmpty ? descriptionNoTemplates : description}</TextBody>
		<TemplateList paymentType={paymentType} />

		<Button width="flush" onClick={handleCreateNewTemplate} data-test-id="create-template-button">
			<Icon iconType="PlusOutlineLarge" className="c-a-button__icon" direction="left" />
			{createTemplateButtonText}
		</Button>
	</StyledTemplateSection>
);
TemplateSelector.propTypes = {
	paymentType: PropTypes.string,
	handleCreateNewTemplate: PropTypes.func,
	content: PropTypes.shape({
		header: PropTypes.string,
		description: PropTypes.string,
		createTemplateButtonText: PropTypes.string,
		descriptionNoTemplates: PropTypes.string,
	}),
	isTemplateListEmpty: PropTypes.bool,
};

const connectWrapper = connect(mapState);
const contentWrapper = withContent({ content: templateSelectorContent });

export default compose(connectWrapper, contentWrapper)(TemplateSelector);
